'use client';
import { CheckboxIcon } from './CheckboxIcon.js';

var IDENT = "Checkbox";
var defaultProps = {
    transitionDuration: 250,
    spacing: 8,
    icon: CheckboxIcon,
    size: "sm1"
};

export { IDENT, defaultProps };
